if (!window.customElements.get('multicolumn-popup')) {
  class MulticolumnPopup extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector('[data-multicolumn-popup-overlay]');
      this.closeButtons = this.querySelectorAll('[data-multicolumn-popup-close]');
      this.copyButtons = this.querySelectorAll('[data-multicolumn-popup-copy]');
      this.triggers = document.querySelectorAll(`[data-multicolumn-popup-trigger="${this.id}"]`);

      this.triggers.forEach((trigger) => trigger.addEventListener('click', () => this.open()));
      this.closeButtons.forEach((closeButton) => closeButton.addEventListener('click', () => this.close()));
      this.copyButtons.forEach((copyButton) => copyButton.addEventListener('click', () => this.copyCode(copyButton)));

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          this.close();
        }
      });
    }

    open() {
      document.body.classList.add('overflow-hidden');
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');

      if (typeof window.trapFocus === 'function') {
        window.trapFocus(this);
      }
    }

    close() {
      document.body.classList.remove('overflow-hidden');
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');

      if (typeof window.removeTrapFocus === 'function') {
        window.removeTrapFocus();
      }
    }

    copyCode(button) {
      const code = button.getAttribute('data-code');
      if (!code) return;

      const showCopied = () => {
        const copiedLabel = button.getAttribute('data-copied-label') || 'Copied';
        const copyLabel = button.getAttribute('data-copy-label') || button.textContent.trim();
        button.textContent = copiedLabel;
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          button.textContent = copyLabel;
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(code)
          .then(showCopied)
          .catch(() => this.fallbackCopy(code, showCopied));
      } else {
        this.fallbackCopy(code, showCopied);
      }
    }

    fallbackCopy(code, onSuccess) {
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        onSuccess();
      } catch (error) {
        // Clipboard unavailable; leave the code visible for manual copy.
      }

      document.body.removeChild(textarea);
    }
  }

  window.customElements.define('multicolumn-popup', MulticolumnPopup);
}
